var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo, useState } from "react";
import { categories, downData, seriesFn } from "../resources/customReportsDTO";
var useUpdateData = function (Tl) {
    var _a = useState(downData), newDownData = _a[0], setNewDownData = _a[1];
    var _b = useState(seriesFn(Tl)), dataSeries = _b[0], setDataSeries = _b[1];
    var _c = useState(categories), dataCategories = _c[0], setDataCategories = _c[1];
    var updateData = useCallback(function (responseAllQuote) {
        var filteredPolicy = responseAllQuote.filter(function (item) { var _a; return ((_a = item.catalogStatusQuote) === null || _a === void 0 ? void 0 : _a.description) === "Emitida"; });
        var quotedPolicy = responseAllQuote.filter(function (item) { var _a; return ((_a = item.catalogStatusQuote) === null || _a === void 0 ? void 0 : _a.description) === "Cotizada"; });
        var salesCount = filteredPolicy.length;
        var quotedPolicyCount = quotedPolicy.length;
        setNewDownData(function (prevData) {
            return prevData.map(function (card) {
                switch (card.id) {
                    case "1":
                        return __assign(__assign({}, card), { numericalTitle: quotedPolicyCount.toString() });
                    case "2":
                        return __assign(__assign({}, card), { numericalTitle: salesCount.toString() });
                    default:
                        return card;
                }
            });
        });
        //LLENA LA DATA DEL CHART
        var productCount = {};
        responseAllQuote.forEach(function (item) {
            var _a, _b, _c;
            var productId = (_a = item === null || item === void 0 ? void 0 : item.productId) === null || _a === void 0 ? void 0 : _a.id;
            var description = (_b = item === null || item === void 0 ? void 0 : item.productId) === null || _b === void 0 ? void 0 : _b.description;
            var status = (_c = item === null || item === void 0 ? void 0 : item.catalogStatusQuote) === null || _c === void 0 ? void 0 : _c.description;
            if (!productCount[productId]) {
                productCount[productId] = {
                    description: description,
                    countsByStatus: {},
                };
            }
            if (productCount[productId].countsByStatus[status]) {
                productCount[productId].countsByStatus[status] += 1;
            }
            else {
                productCount[productId].countsByStatus[status] = 1;
            }
        });
        var sortedProducts = Object.keys(productCount)
            .map(function (key) {
            var product = productCount[key];
            var totalCount = Object.values(product.countsByStatus).reduce(function (sum, count) { return sum + count; }, 0);
            return __assign(__assign({}, product), { id: key, totalCount: totalCount });
        })
            .sort(function (a, b) { return b.totalCount - a.totalCount; });
        var top5Products = sortedProducts.slice(0, 5);
        var issuedData = top5Products.map(function (product) { return product.countsByStatus["Emitida"] || 0; });
        var listedData = top5Products.map(function (product) { return product.countsByStatus["Cotizada"] || 0; });
        var categoriesData = top5Products.map(function (product) { return product.description; });
        setDataSeries(function (prevSeries) {
            return [
                __assign(__assign({}, prevSeries[0]), { data: issuedData }),
                __assign(__assign({}, prevSeries[1]), { data: listedData }),
            ];
        });
        setDataCategories(categoriesData);
    }, []);
    return useMemo(function () { return ({
        newDownData: newDownData,
        dataSeries: dataSeries,
        dataCategories: dataCategories,
        updateData: updateData,
    }); }, [newDownData, dataSeries, dataCategories, updateData]);
};
export default useUpdateData;
